import React from 'react';

function CircleEmptyIcon({stroke , fill}) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="9.15" fill={fill} stroke={stroke} strokeWidth="1.7"/>
        </svg>
    );
}

export default CircleEmptyIcon;
